import api from './api';
import { Location } from '../types/models';

export async function listLocations(countryCode?: string, stateCode?: string): Promise<Location[]> {
  const res = await api.get('/locations', { params: { countryCode, stateCode } });
  return res.data.locations;
}
